import { map, Observable, switchMap, take } from 'rxjs';
import { inject } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { GameDetailsModel, mapCommonGameDto } from '@core';
import { isSameDay } from 'date-fns';
import { NearbyGamesService } from '@find-games/infra';
import { CommonGameDto, LocationGamesDto } from '@core-http';
import { GetLocationDetailsQueryResult } from './get-location-details.query-result';

export class GetLocationDetailsQueryHandler {
  private readonly nearbyGamesService: NearbyGamesService = inject(NearbyGamesService);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  getDetails(): Observable<GetLocationDetailsQueryResult> {
    return this.activatedRoute.params.pipe(
      switchMap((params: Params) =>
        this.nearbyGamesService.getLocationDetails(params['id']).pipe(
          take(1),
          map((dto: LocationGamesDto) => this.mapToQueryResult(dto))
        )
      )
    );
  }

  private mapToQueryResult(dto: LocationGamesDto): GetLocationDetailsQueryResult {
    const today: Date = new Date();
    const games: CommonGameDto[] = dto.games || [];

    const todayGames: GameDetailsModel[] = games
      .filter((game: CommonGameDto) => isSameDay(today, new Date(game.gameDateStart)))
      .map((game: CommonGameDto) => mapCommonGameDto(game));

    const futureGames: GameDetailsModel[] = games
      .filter((game: CommonGameDto) => new Date(game.gameDateStart).setHours(0, 0, 0, 0) > today.setHours(0, 0, 0, 0))
      .map((game: CommonGameDto) => mapCommonGameDto(game));

    return {
      locationId: dto.locationId,
      name: dto.name,
      address: dto.address,
      todayGames,
      futureGames
    };
  }
}
